import type { AuthSession } from "@reminder-tracker/auth";
import type { HouseholdSummary, OperationalContext } from "@reminder-tracker/backend-contracts";

export const syntheticAdultSession: AuthSession = Object.freeze({
  providerSubject: "synthetic_adult_001",
  providerSessionId: "synthetic_session_001",
  applicationContext: "consumer-web",
  environment: "local",
  organizationId: null,
  role: null,
  roles: [],
  permissions: [],
  authenticatedAtEpochSeconds: null,
  issuedAtEpochSeconds: 1_700_000_000,
  expiresAtEpochSeconds: 2_000_000_000,
});

export const syntheticHouseholdSummary: HouseholdSummary = Object.freeze({
  householdId: "hh_synthetic_001",
  name: "Sample household",
  role: "owner",
  memberCount: 2,
  collaboration: {
    state: "SHARED",
    capabilities: {
      canCreateReminders: true,
      canInvitePeople: true,
      canManagePeople: true,
      canChooseReminderVisibility: true,
    },
  } as const,
  locale: "en-GB",
  timeZone: "Europe/London",
  revision: 1,
  ownDisplayName: null,
  ownMembershipRevision: 1,
});

export const syntheticOperationalContext: OperationalContext = Object.freeze({
  environment: "local",
  dataPolicy: "synthetic-only",
  householdCount: 1,
  adultCount: 2,
  trackedRenewalCount: 0,
  reminderOccurrenceCount: 0,
  reminderContentAccessible: false,
});
